<template>
  <DragDialog
    :title="title"
    :width="400"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel"
    class="dialog-primary-light">
    <el-form
      @submit.native.prevent
      :model="form"
      class="form public-form-primary"
      label-width="60px"
      :rules="rules"
      ref="form">
      <el-form-item
        class="form-item"
        label="名称:"
        prop="nodeName">
        <el-input
          class="input-primary addFileName"
          size="small"
          :maxlength="100"
          show-word-limit
          v-model="form.nodeName"
          :placeholder="`请输入${nodeType === 1 ? '文件夹' : '模型组'}名称`" />
      </el-form-item>
      <!-- linux环境下不支持链接模型的转换 -->
      <div
        v-if="editMode === 'addNode' && nodeType === 2 && !isLinux"
        class="common-checkbox-box">
        <el-checkbox
          class="checkbox-primary"
          v-model="form.isLinkModel">
          链接模型
        </el-checkbox>
      </div>
    </el-form>
    <div
      class="tip-box"
      v-if="form.isLinkModel">
      <!-- <div class="icon-box">
        <icon-svg icon-class="icon-zhuyitishi" />
      </div> -->
      <div class="text-box">
        <div class="public-tips-primary">注：</div>
        <div>
          <div class="public-tips-primary">
            (1)
            为保证整体效果，建议上传所有链接文件，无链接关系的模型将不参与转换
          </div>
          <div class="public-tips-primary">
            (2) Revit链接文件在线转换功能仅限于2016-2021版
          </div>
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
export default {
  data() {
    const validDisplayNameRule = (rule, value, callback) => {
      if (value.length === value.trimStart().trimEnd().length) {
        return callback()
      } else {
        callback(new Error('开头和结尾不允许有空格'))
      }
    }
    return {
      isLinux: window.isLinux,
      disabled: false,
      form: {
        nodeName: '',
        isLinkModel: false
      },
      rules: {
        nodeName: [
          {
            required: true,
            // eslint-disable-next-line
            message: '请输入文件夹名称',
            trigger: 'blur'
          },
          { validator: validDisplayNameRule }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    title: String,
    schemeType: String,
    nodeType: Number,
    editMode: String,
    nodeInfo: Object,
    submitNode: Function,
    closeDialog: Function,
    nodeTreeType: {
      type: [String, Number],
      default: 1,
      required: false
    }
  },
  components: {
    DragDialog
  },
  watch: {
    nodeInfo: function (newValue) {
      if (newValue) {
        this.form = {
          nodeName: newValue.nodeName
        }
      }
    },
    nodeType: function (newValue) {
      if (newValue === 1) {
        this.rules.nodeName[0].message = '请输入文件夹名称'
      } else {
        this.rules.nodeName[0].message = '请输入模型组名称'
      }
    }
  },
  methods: {
    submit() {
      let startInterval = setInterval(() => {
        this.disabled = false
        clearInterval(startInterval)
      }, 60000)

      if (!this.disabled) {
        this.$refs.form.validate((bool, object) => {
          if (bool) {
            let paramsInfo = {
              nodeName: this.form.nodeName,
              isLinkModel: this.form.isLinkModel
            }
            this.submitNode(paramsInfo).then(response => {
              if (response.isSuccess) {
                this.disabled = false
                this.clearForm()
                this.closeDialog()
              } else {
                this.disabled = false
                this.$message.error(response.errMsg)
                return
              }
            })
          } else {
            this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
            this.disabled = false
            return
          }
          this.disabled = true
        })
      }
    },
    cancel() {
      this.clearForm()
      this.closeDialog()
    },
    clearForm() {
      this.form = {
        nodeName: '',
        isLinkModel: false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.form {
  padding: 5px 0px;
  .form-item {
    margin-bottom: 15px;
    :deep(.el-input__inner)::placeholder {
      font-weight: 400;
    }
  }

  .common-checkbox-box {
    margin-left: 60px;
  }
}

.addFileName {
  :deep(.el-input__inner) {
    padding-right: 56px !important;
  }
}

.tip-box {
  display: flex;
  margin-left: 60px;

  .icon-box {
    margin: -4px -3px;
    font-size: 20px;
    color: #73fbfd;
  }

  .text-box {
    display: flex;
    margin-left: 10px;
    font-size: 12px;
    line-height: 20px;
    color: var(--page-tips-text-color);
  }
}
</style>
